import { render, staticRenderFns } from "./DispositivosSim.vue?vue&type=template&id=5e6c128c&"
import script from "./DispositivosSim.vue?vue&type=script&lang=ts&"
export * from "./DispositivosSim.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('5e6c128c', component.options)
    } else {
      api.reload('5e6c128c', component.options)
    }
    module.hot.accept("./DispositivosSim.vue?vue&type=template&id=5e6c128c&", function () {
      api.rerender('5e6c128c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/RecepcionEquipos/Acciones/DispositivosSim.vue"
export default component.exports